export const rosterRouter = [
  {
    path: "/staff-manage/roster/list",
    name: "roster-list",
    meta: { title: "员工花名册" },
    component: () =>
      import(/* webpackChunkName: "roster-list" */ "@/views/staff-manage/roster/list/index.vue"),
  },
  {
    path: "/staff-manage/roster/edit/:id",
    name: 'roster-edit',
    meta: { title: '编辑员工人事信息' , comName:"StaffManageRosterFormCreate" },
    hidden: true,
    component: () => import(/* webpackChunkName: "roster-edit" */ "@/views/staff-manage/roster/form-create/index.vue")
  },
  {
    path: "/staff-manage/roster/detail/:id",
    name: 'roster-detail',
    meta: { title: '员工人事信息详情' },
    hidden: true,
    component: () => import(/* webpackChunkName: "roster-detail" */ "@/views/staff-manage/roster/form-detail/index.vue")
  },
  {
    hidden: true,
    path: "/staff-manage/roster/flowPrint/:id",
    name: "staff-roster-flow-print",
    meta: { title: "流程打印" },
    component: () =>
      import(
        /* webpackChunkName: "project-profile" */ "@/views/staff-manage/roster/flow-print/index.vue"
      ),
  },
]
